"use client";

import AuthHeader from '../auth-header'
import AuthImage from '../auth-image'
import { FormProvider, useForm } from 'react-hook-form';
import Input from '@/src/components/Input';
import Button from '@/src/components/Button';
import { useUserStore } from '@/src/stores/useUserStore';
import { useEffect, useState } from 'react';

// export const metadata = {
//   title: 'Reset Password - Mosaic',
//   description: 'Page description',
// }

export default function ResetPassword() {
  const { forgotPassword, error, reset } = useUserStore();
  const [msg, setMsg] = useState<string | null>(null)
  const methods = useForm();

  useEffect(() => {
    reset();
  }, []);
  
  const onSubmit = async (data: any) => {
    const msg = await forgotPassword(data);
    setMsg(msg);
  };

  return (
    <main className="bg-white dark:bg-gray-900">

      <div className="relative md:flex">

        {/* Content */}
        <div className="md:w-1/2">
          <div className="min-h-[100dvh] h-full flex flex-col after:flex-1">

            <AuthHeader />

            <div className="max-w-sm mx-auto w-full px-4 py-8">
              <h1 className="text-3xl text-gray-800 dark:text-gray-100 font-bold mb-6">Reset your Password</h1>
              {/* Form */}
              <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(onSubmit)}>
                  <div className="space-y-4">
                    <div>
                      <Input
                        label={"Email Address"}
                        type="email"
                        name="email"
                        placeholder="name@mail.com"
                        required
                      />
                    </div>
                    {msg ? <small><i>{msg}</i></small> : null}
                  </div>
                  <div className="flex justify-end mt-6">
                    <Button
                      type="submit"
                      className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white whitespace-nowrap"
                    >
                      Send Reset Link
                    </Button>
                  </div>
                </form>
              </FormProvider>
            </div>

          </div>
        </div>

        <AuthImage />

      </div>

    </main>
  )
}
